module.exports = __webpack_public_path__ + "static/media/tracking.6d3b0a77.svg";